import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Typography, Spacer, Button, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { RoundCallSuccess } from '@icons';
import { useNavigation } from '@navigation';
import { Anything } from '@types';

export interface RequestToCallSuccessProps {
	nameToContact: string;
}
export const RequestToCallSuccess: React.FC<RequestToCallSuccessProps> = (props) => {
	const t = useTranslation();
	const { palette } = useTheme();
	const { nameToContact } = props;
	const { back } = useNavigation();
	return (
		<Box
			styles={{
				flexDirection: 'column',
				minHeight: '100%',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box>
				<RoundCallSuccess />
			</Box>
			<Box styles={{ margin: rem(24, 0, 48, 0), flexDirection: 'column', alignItems: 'center' }}>
				<Typography appearance="headline-200-02">
					{t('placeholders.requestToCallSuccess.title', { nameToContact })}
				</Typography>
				<Spacer vertical={8} />
				<Typography
					alternativeStyleProperties={
						{
							color: palette.global.ui9,
						} as Anything
					}
					appearance="body-100-02"
				>
					{t('placeholders.requestToCallSuccess.subTitle')}
				</Typography>
			</Box>
			<Box>
				<Button
					onPress={() => {
						back();
					}}
				>
					{t('placeholders.requestToCallSuccess.button.title')}
				</Button>
			</Box>
		</Box>
	);
};
